import { Component, OnInit } from '@angular/core';
import { environment } from '../../../';
import { CookieManagerService, ErrorManagerService } from '../../../shared/';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-redirect',
  template: 'Payment...'
})
export class RedirectComponent implements OnInit {

  paymentType: string;
  token: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/redirect.component.ts